import EmailVerifyView from './EmailVerifyView'

export default EmailVerifyView
